import { Box, Typography, FormControlLabel, Checkbox } from "@mui/material";
import AddressForm from "./AddressForm";

const Shipping = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  return (
    <Box>
      {/* BILLING FORM */}
      <Typography sx={{ mb: "15px" }} fontSize="18px">
        Billing Information
      </Typography>
      <AddressForm
        type="billingAddress"
        values={values.billingAddress}
        errors={errors.billingAddress || {}}
        touched={touched.billingAddress || {}}
        handleBlur={handleBlur}
        handleChange={handleChange}
      />

      {/* SHIPPING FORM */}
      <Box>
        <Typography sx={{ mb: "15px" }} fontSize="18px">
          Shipping Information
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              defaultChecked
              value={values.shippingAddress.isSameAddress}
              onChange={() =>
                setFieldValue(
                  "shippingAddress.isSameAddress",
                  !values.shippingAddress.isSameAddress
                )
              }
            />
          }
          label="Same as billing address"
        />
        {!values.shippingAddress.isSameAddress && (
          <AddressForm
            type="shippingAddress"
            values={values.shippingAddress}
            errors={errors.shippingAddress || {}}
            touched={touched.shippingAddress || {}}
            handleBlur={handleBlur}
            handleChange={handleChange}
          />
        )}
      </Box>
    </Box>
  );
};

export default Shipping;
